import React from 'react'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { string, object, mixed, boolean } from 'yup'
import { Form } from '@superhi/design'

import { API } from '../../../../api'
import BaseForm from '../../_templates/BaseForm'
import * as config from '../config'
import { configToInput } from '../../utils'

import QUERY from './queries'
import MUTATION from './mutations'

type FormValues = {
  name: string
  slug: string
  description: string
  isSuperhi: boolean
  startedOn?: string
  image: {
    url?: string
    value: string
    file: any
  }
  jobTitle: string
  location?: string
  facebook?: string
  instagram?: string
  twitter?: string
}

const PersonUpdate: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { id } = useParams<any>()
  const { data } = useQuery<API.people_update>(QUERY, { variables: { id } })

  if (!data?.person) {
    return null
  }

  return (
    <BaseForm<FormValues, API.PersonUpdateMutationVariables>
      initialValues={{
        name: data.person.name,
        slug: data.person.slug,
        isSuperhi: data.person.isSuperhi,
        description: data.person.description,
        jobTitle: data.person.jobTitle,
        startedOn: data.person.startedOn || undefined,
        location: data.person.location || undefined,
        facebook: data.person.facebook || undefined,
        instagram: data.person.instagram || undefined,
        twitter: data.person.twitter || undefined,
        image: {
          url: data.person.image.url,
          value: '',
          file: undefined,
        },
      }}
      validationSchema={{
        name: string().required(),
        slug: string().required(),
        description: string().required(),
        isSuperhi: boolean().required(),
        jobTitle: string().required(),
        location: string(),
        startedOn: string(),
        facebook: string(),
        instagram: string(),
        twitter: string(),
        image: object({
          url: string().required(),
          value: string(),
          file: mixed(),
        }).required(),
      }}
      mutation={MUTATION}
      createVariablesFn={(formValues) => ({
        id,
        ...formValues,
        image: formValues.image.file || undefined,
      })}
    >
      <Form.Row>{configToInput(config.NAME)}</Form.Row>

      <Form.Row>{configToInput(config.SLUG)}</Form.Row>

      <Form.Row>{configToInput(config.DESCRIPTION)}</Form.Row>

      <Form.Row>{configToInput(config.IS_SUPER_HI)}</Form.Row>

      <Form.Row>{configToInput(config.STARTED_ON)}</Form.Row>

      <Form.Row>{configToInput({ ...config.IMAGE, required: false })}</Form.Row>

      <Form.Row>{configToInput(config.JOB_TITLE)}</Form.Row>

      <Form.Row>{configToInput(config.LOCATION)}</Form.Row>

      <Form.Row>{configToInput(config.FACEBOOK)}</Form.Row>

      <Form.Row>{configToInput(config.INSTAGRAM)}</Form.Row>

      <Form.Row>{configToInput(config.TWITTER)}</Form.Row>
    </BaseForm>
  )
}

export default PersonUpdate
